<template>
  <div class="frisbuy-customer-review">
    <div
      class="frisbuy-customer-review__top-section"
      :style="{
        order: props.topSectionConfig.order,
        margin: props.topSectionConfig.margin,
      }"
    >
      <div class="frisbuy-customer-review__customer-info">
        <div class="frisbuy-customer-review__customer-name">
          <span>{{ props.customerName }}</span>
        </div>
        <div
          v-if="props.rating"
          class="frisbuy-customer-review__customer-rating"
        >
          <Vue3StarRating
            :modelValue="props.rating"
            :numberOfStars="5"
            :starSize="22"
            :starColor="'#606266'"
            :inactiveColor="'#E9E9EB'"
            :disableClick="true"
            :customSvg="isSoftStarIcon ? StarSoftRounded : StarRounded"
          />
        </div>
      </div>

      <div class="frisbuy-customer-review__source">
        <div class="frisbuy-customer-review__date">
          <time :datetime="props.reviewDate">
            {{ props.reviewDate }}
          </time>
        </div>
        <div class="frisbuy-customer-review__time">
          <span class="frisbuy-customer-review__time-preposition"> в </span>
          <span class="frisbuy-customer-review__time-numbers">
            {{ props.reviewTime }}
          </span>
        </div>

        <div
          v-if="props.reviewMarketplace"
          class="frisbuy-customer-review__marketplace"
        >
          <span class="frisbuy-customer-review__marketplace-preposition">
            на
          </span>
          <span class="frisbuy-customer-review__marketplace-name">
            {{ props.reviewMarketplace }}
          </span>
        </div>
      </div>

      <div
        v-if="uniqueProductLinks.length > 0"
        class="frisbuy-customer-review__product-info"
      >
        <span class="product-info-prefix">К товару:</span>
        <span v-for="product in uniqueProductLinks" :key="product.link">
          <a class="product-info-link" :href="product.link">
            <span>{{ product.title }}</span>
          </a>
        </span>
      </div>
    </div>

    <div
      v-if="props.isShowMedia && props.mediaList && props.mediaList.length > 0"
      class="frisbuy-customer-review__media-section"
      :style="{
        order: props.mediaSectionConfig.order,
        margin: props.mediaSectionConfig.margin,
      }"
    >
      <MediaList
        :mediaList="props.mediaList"
        :wrap="props.mediaSectionConfig.wrap"
        :gap="props.mediaSectionConfig.gap"
        :mediaWidth="props.mediaSectionConfig.mediaWidth"
        :mediaHeight="props.mediaSectionConfig.mediaHeight"
        :mediaAspectRatio="props.mediaSectionConfig.mediaAspectRatio"
        @selectMedia="(media) => selectPostWithPhoto(media)"
      />
    </div>

    <div
      v-if="props.positiveComment || props.negativeComment || props.text"
      class="frisbuy-customer-review__text"
      :style="{
        order: props.textSectionConfig.order,
        margin: props.textSectionConfig.margin,
      }"
    >
      <div
        v-if="props.positiveComment"
        class="frisbuy-customer-review__text--positive"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M20.7633 12.51C21.157 11.9897 21.375 11.3522 21.375 10.6889C21.375 9.63654 20.7867 8.64045 19.8398 8.08498C19.5961 7.942 19.3185 7.86675 19.0359 7.86701H13.4156L13.5563 4.98654C13.5891 4.29045 13.343 3.62951 12.8648 3.1256C12.6302 2.87723 12.3471 2.67962 12.0331 2.54497C11.7191 2.41033 11.3807 2.34152 11.0391 2.34279C9.82031 2.34279 8.74219 3.1631 8.41875 4.33732L6.40547 11.6264H6.39844V21.6576H17.468C17.6836 21.6576 17.8945 21.6154 18.0891 21.5311C19.2047 21.0553 19.9242 19.9654 19.9242 18.7561C19.9242 18.4608 19.882 18.1701 19.7977 17.8889C20.1914 17.3686 20.4094 16.7311 20.4094 16.0678C20.4094 15.7725 20.3672 15.4819 20.2828 15.2006C20.6766 14.6803 20.8945 14.0428 20.8945 13.3795C20.8898 13.0842 20.8477 12.7912 20.7633 12.51ZM2.625 12.3764V20.9076C2.625 21.3225 2.96016 21.6576 3.375 21.6576H4.89844V11.6264H3.375C2.96016 11.6264 2.625 11.9615 2.625 12.3764Z"
            fill="black"
            fill-opacity="0.45"
          />
        </svg>

        <span>
          {{ props.positiveComment }}
        </span>
      </div>

      <div
        v-if="props.negativeComment"
        class="frisbuy-customer-review__text--negative"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M3.23672 11.4905C2.84297 12.0108 2.625 12.6483 2.625 13.3116C2.625 14.3639 3.21328 15.36 4.16016 15.9155C4.40392 16.0585 4.68146 16.1337 4.96406 16.1335H10.5844L10.4437 19.0139C10.4109 19.71 10.657 20.371 11.1352 20.8749C11.3698 21.1233 11.6529 21.3209 11.9669 21.4555C12.2809 21.5902 12.6193 21.659 12.9609 21.6577C14.1797 21.6577 15.2578 20.8374 15.5812 19.6632L17.5945 12.3741H17.6016V2.34285H6.53203C6.31641 2.34285 6.10547 2.38504 5.91094 2.46942C4.79531 2.9452 4.07578 4.03504 4.07578 5.24442C4.07578 5.53973 4.11797 5.83035 4.20234 6.1116C3.80859 6.63192 3.59063 7.26942 3.59063 7.9327C3.59063 8.22801 3.63281 8.51863 3.71719 8.79988C3.32344 9.3202 3.10547 9.9577 3.10547 10.621C3.11016 10.9163 3.15234 11.2093 3.23672 11.4905ZM21.375 11.6241V3.09285C21.375 2.67801 21.0398 2.34285 20.625 2.34285H19.1016V12.3741H20.625C21.0398 12.3741 21.375 12.0389 21.375 11.6241Z"
            fill="black"
            fill-opacity="0.45"
          />
        </svg>

        <span> {{ props.negativeComment }} </span>
      </div>

      <div v-if="props.text" class="frisbuy-customer-review__text--comment">
        <span> {{ props.text }} </span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
$text-color-primary: #303133;
$text-color-secondary: #606266;

.frisbuy-customer-review {
  *,
  *::before,
  *::after {
    box-sizing: border-box;

    font-family: Inter, sans-serif;
  }

  display: flex;
  flex-direction: column;

  .frisbuy-customer-review__top-section {
    .frisbuy-customer-review__customer-info {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .frisbuy-customer-review__customer-name {
        font-size: 14px;
        font-weight: 700;
        line-height: 22px;

        color: $text-color-primary;
      }
    }

    .frisbuy-customer-review__source {
      white-space: break-spaces;

      & > * {
        display: inline-block;
        width: fit-content;

        font-size: 12px;
        font-weight: 400;
        line-height: 20px;

        text-decoration: underline;

        color: $text-color-secondary;
      }
    }

    .frisbuy-customer-review__product-info {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      gap: 0 6px;

      margin-top: 4px;

      .product-info-prefix {
        color: $text-color-primary;
      }

      .product-info-link {
        color: #337ecc;
        text-decoration: none;

        &:not(:last-of-type) {
          &::after {
            content: ",";
            color: $text-color-primary;
          }
        }
      }

      & > * {
        font-family: Inter;
        font-weight: 500;
        font-size: 13px;
        line-height: 20px;
        letter-spacing: 0px;
      }
    }
  }

  .frisbuy-customer-review__media-section {
    display: block;
  }

  .frisbuy-customer-review__text {
    color: $text-color-primary;

    font-size: 14px;
    font-weight: 400;
    line-height: 22px;

    margin-top: 20px;

    & > *:not(:first-child) {
      margin-top: 5px;
    }

    .frisbuy-customer-review__text--positive,
    .frisbuy-customer-review__text--negative,
    .frisbuy-customer-review__text--comment {
      display: flex;
      flex-direction: row;

      svg {
        flex: 0 0 auto;

        width: 24px;
        height: 24px;

        margin-right: 7px;
      }
    }
  }
}
</style>

<script setup lang="ts">
import Vue3StarRating from "vue3-star-ratings";
import StarRounded from "@/widgets/MarketplaceReviews/Icons/StarRounded.vue";
import StarSoftRounded from "@/widgets/MarketplaceReviews/Icons/StarSoftRounded.vue";
import MediaList, { MediaListCustomization } from "./MediaList.vue";
import { imageWithPostId, postMedia } from "../interfaces";
import { onBeforeMount, ref, watch } from "vue";
import { addSchemaToPage } from "@/common/services/SchemaOrg/SchemaOrg";

//#region Schema.org
onBeforeMount(() => {
  props.mediaList?.forEach((media) => {
    media.linkList.forEach((link) => {
      const Product = link;
      const bestRating = 5;
      // NOTE: if ratingValue === 0 and worstRating === 1, then it will be error
      const worstRating = 1;
      if (!Product) {
        return;
      }

      /* NOTE:
        Google always need to get `ratingValue` and `reviewCount`.
        But sometimes this information may not be available
      */
      if (
        !Product.sku ||
        !Product.sku?.avgRating ||
        !Product.sku?.reviewsCount
      ) {
        return;
      }

      const reviewRating =
        props.rating && props.rating > 0 ? props.rating : bestRating;

      const SchemaorgProduct = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: Product.title,
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: Product.sku.avgRating,
          bestRating: bestRating,
          worstRating: worstRating,
          reviewCount: Product.sku.reviewsCount,
        },

        review: [
          {
            "@type": "Review",

            author: {
              "@type": "Person",
              name: props.customerName,
            },
            datePublished: props.reviewDate,
            reviewBody: `${props.text}\n${props.positiveComment}\n${props.negativeComment}`,

            reviewRating: {
              "@type": "Rating",
              bestRating: bestRating,
              ratingValue: reviewRating,
              worstRating: worstRating,
            },
          },
        ],
      };

      addSchemaToPage(SchemaorgProduct);
    });
  });
});
//#endregion Schema.org

type sectionConfig = {
  order: number;
  margin: string;
};

const props = withDefaults(
  defineProps<{
    customerName: string;
    reviewDate: string;
    reviewTime: string;
    reviewMarketplace?: string;
    rating?: number;
    mediaList?: Array<postMedia>;
    isShowMedia?: boolean;
    negativeComment?: string;
    positiveComment?: string;
    text?: string;

    blocksOrder?: number;
    sectionsMarginTop?: Array<string>;

    topSectionConfig?: sectionConfig;
    mediaSectionConfig?: sectionConfig & MediaListCustomization;
    textSectionConfig?: sectionConfig;
    isSoftStarIcon?: boolean;
  }>(),
  {
    isShowMedia: true,

    topSectionConfig: () => {
      return {
        order: 0,
        margin: "0",
      };
    },
    mediaSectionConfig: () => {
      return {
        order: 1,
        margin: "20px 0 0 0",
      };
    },
    textSectionConfig: () => {
      return {
        order: 2,
        margin: "20px 0 0 0",
      };
    },
  }
);

const emit = defineEmits<{
  (e: "selectMedia", media: imageWithPostId): void;
}>();

function selectPostWithPhoto(media: imageWithPostId) {
  emit("selectMedia", media);
}

//#region unique product links
type ProductLinkInfo = {
  link: string;
  title: string;
};
const uniqueProductLinks = ref<Array<ProductLinkInfo>>([]);
onBeforeMount(() => {
  uniqueProductLinks.value = getUniqueProductLinks();
});

watch(
  () => props.mediaList,
  () => {
    uniqueProductLinks.value = getUniqueProductLinks();
  }
);

function getUniqueProductLinks(): Array<ProductLinkInfo> {
  const uniqueLinks: Array<ProductLinkInfo> = [];
  const uniqueLinksInStringifyFormat = new Set<string>();

  props.mediaList?.forEach((media) => {
    media.linkList.forEach((link) => {
      const productInfo = {
        link: link.link,
        title: link.title,
      };

      uniqueLinksInStringifyFormat.add(JSON.stringify(productInfo));
    });
  });

  uniqueLinksInStringifyFormat.forEach((linkInStringifyFormat) => {
    uniqueLinks.push(JSON.parse(linkInStringifyFormat));
  });

  return uniqueLinks;
}
//#endregion unique product links
</script>
